import { Action } from '@ngrx/store';

export enum FilialsActionTypes {
  GET_FILIALS = '[SHARED TOAST] Get Filials',
  GET_FILIALS_SUCCESS = '[SHARED TOAST] Get Filials Success',
  GET_FILIALS_ERROR = '[SHARED TOAST] Get Filials Error',

  GET_FILIAL_BY_CITY = '[SHARED TOAST] Get Filial by city',
  GET_FILIAL_BY_CITY_SUCCESS = '[SHARED TOAST] Get Filial by city Success',
  GET_FILIAL_BY_CITY_ERROR = '[SHARED TOAST] Get Filial by city Error',

  GET_FILIAL_BY_MANAGER = '[SHARED TOAST] Get Filial by Manager',
  GET_FILIAL_BY_MANAGER_SUCCESS = '[SHARED TOAST] Get Filial by Manager Success',
  GET_FILIAL_BY_MANAGER_ERROR = '[SHARED TOAST] Get Filial by Manager Error',
}

export class GetFilials implements Action {
  readonly type = FilialsActionTypes.GET_FILIALS;
}
export class GetFilialsSuccess implements Action {
  readonly type = FilialsActionTypes.GET_FILIALS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetFilialsError implements Action {
  readonly type = FilialsActionTypes.GET_FILIALS_ERROR;
  constructor(public payload: any) {}
}

export class GetFilialsbyCity implements Action {
  readonly type = FilialsActionTypes.GET_FILIAL_BY_CITY;
  constructor(public payload: any) {}
}
export class GetFilialsbyCitySuccess implements Action {
  readonly type = FilialsActionTypes.GET_FILIAL_BY_CITY_SUCCESS;
  constructor(public payload: any) {}
}
export class GetFilialsbyCityError implements Action {
  readonly type = FilialsActionTypes.GET_FILIAL_BY_CITY_ERROR;
  constructor(public payload: any) {}
}

export class GetFilialbyManager implements Action {
  readonly type = FilialsActionTypes.GET_FILIAL_BY_MANAGER;
  constructor(public manager_id: any) {}
}
export class GetFilialbyManagerSuccess implements Action {
  readonly type = FilialsActionTypes.GET_FILIAL_BY_MANAGER_SUCCESS;
  constructor(public payload: any) {}
}
export class GetFilialbyManagerError implements Action {
  readonly type = FilialsActionTypes.GET_FILIAL_BY_MANAGER_ERROR;
  constructor(public payload: any) {}
}

export type FilialActions =
  | GetFilials
  | GetFilialsSuccess
  | GetFilialsError
  | GetFilialsbyCity
  | GetFilialsbyCitySuccess
  | GetFilialsbyCityError
  | GetFilialbyManager
  | GetFilialbyManagerSuccess
  | GetFilialbyManagerError;
